import { DATA_COLORS } from "../../../util/constants";
import { featureConversion } from "./analysisUtils";

import * as R from "rambda";


function generateMetricDataFromIds(ids, passedSubjects, passedFeature, featureData, type) {
    let metricData = []
    for (let i = 0; i < ids.length; i++) {
            var newMetricData = passedFeature.map((item, index) => {
                const data = R.path(
                    ["result", ids[i], item.id, "data"],
                    featureData
                )
                // get count of non-null values
                const count = data?.filter(x => x !== null).length;

                return {
                    id: ids[i],
                    y: data,
                    x: R.path(
                        ["result", ids[i], item.id, "dates"],
                        featureData
                    ),
                    symbol: R.path(
                        ["result", ids[i], item.id, "unit", "symbol"],
                        featureData
                    ),
                    name: `${type}:${passedSubjects.find(x => x.name === ids[i])?.shortname} <br> ${item.name}`,
                    featureName: item.name,
                    text: `${type}:${passedSubjects.find(x => x.name === ids[i])?.shortname}`,
                    hovertemplate: `%{y}(${R.path(
                        ["result", ids[i], item.id, "unit", "symbol"],
                        featureData
                    )})`,
                    type: "scatter",
                    showlegend: true,
                    mode: "lines+markers",
                    marker: {
                        size: count > 10 ? 3 : 8,
                    },
                    line: {
                        color: DATA_COLORS[index].color,
                    },
                }
            });
            metricData = [...metricData, ...newMetricData];
        }
    return metricData;
}


export const generateMetricData = (sensorIDs, cmlIDs, passedFeature, sensorData, cmlData, context, passedSubjects) => {
    let metricData = [];

    if (sensorIDs.length > 0) {
        let newMetricData = generateMetricDataFromIds(sensorIDs, passedSubjects, passedFeature, sensorData, "Sensor");
        metricData = [...metricData, ...newMetricData];
    }

    if (cmlIDs.length > 0) {
        let newMetricData = generateMetricDataFromIds(cmlIDs, passedSubjects, passedFeature, cmlData, "CML");
        metricData = [...metricData, ...newMetricData];
    }

    return metricData;
}